import Link from 'next/link';

import StocktwitsLogo from '@/assets/logos/stocktwits-logo.svg';
import ThematicLogo from '@/assets/logos/thematic-cube-logo.svg';
import { Paragraph } from '@/components/dom/text-elements';

export const StocktwitsAcquisitionAnnouncementBanner = () => {
    return (
        <Link
            href="https://stocktwits.com/news-articles/business/others/stocktwits-acquires-ai-startup-thematic/ch8KVxsR5pd"
            target="_blank"
            className="group"
        >
            <aside
                role="banner"
                aria-label="Site announcement"
                className="py-2 md:py-4 px-2 xs:px-4 md:px-8 relative z-200"
            >
                <Paragraph className="mx-auto mb-0 text-stocktwits-light-blue bg-stocktwits-black bg-gradient-to-r from-stocktwits-blue/80 from-13% via-stocktwits-black/50 via-59% to-stocktwits-purple to-100% py-3 px-12 rounded-full max-w-screen-lg text-center">
                    <StocktwitsLogo className="text-white h-5 inline-block align-middle -translate-y-[2px]" />
                    <span className="hidden md:inline mx-2">acquires</span>
                    <span className="inline md:hidden mx-2">X</span>
                    <ThematicLogo className="text-white h-6 inline-block align-middle -translate-y-[2px]" />
                    <span className="hidden md:inline">
                        &nbsp;to elevate market intelligence with AI&#45;powered investment insights &ndash;
                    </span>
                    &nbsp;
                    <span className="font-brand-md text-white group-hover:text-stocktwits-blue transition-colors">
                        Read more&nbsp;<span className="hidden md:inline">here</span>
                    </span>
                </Paragraph>
            </aside>
        </Link>
    );
};
